import * as React from 'react';
import { DSMenuItem } from '../../../..';

export type SelectButtonOptionProps = {
    dataCy?: string;
    disabled?: boolean;
    children: React.ReactNode;
    onClick?: () => void;
};

export function SelectButtonOption({ children, dataCy, disabled, onClick }: SelectButtonOptionProps): JSX.Element {
    return (
        <DSMenuItem data-cy={dataCy} disabled={disabled} value="no-value" onClick={onClick}>
            {children}
        </DSMenuItem>
    );
}
SelectButtonOption.displayName = 'SelectButtonOption';
